import { render, staticRenderFns } from "./AboutPlatform.vue?vue&type=template&id=ecc65d34&scoped=true&"
import script from "./AboutPlatform.vue?vue&type=script&lang=js&"
export * from "./AboutPlatform.vue?vue&type=script&lang=js&"
import style0 from "./AboutPlatform.vue?vue&type=style&index=0&id=ecc65d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc65d34",
  null
  
)

export default component.exports